import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PisteIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "16.5",
                fill: "white",
                stroke: "#FFDF00",
                "stroke-width": "3"
            }),
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_66_86",
                maskUnits: "userSpaceOnUse",
                x: "8",
                y: "8",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ _jsx("rect", {
                    x: "8",
                    y: "8",
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                mask: "url(#mask0_66_86)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M17.25 26V22C17.25 21.25 17.1354 20.6875 16.9062 20.3125C16.6771 19.9375 16.375 19.5764 16 19.2292L17.0625 18.1667C17.2292 18.3194 17.3924 18.4826 17.5521 18.6562C17.7118 18.8299 17.8611 19.0208 18 19.2292C18.1806 18.9653 18.375 18.7326 18.5833 18.5312C18.7917 18.3299 19 18.1319 19.2083 17.9375C19.7361 17.4514 20.2083 16.8889 20.625 16.25C21.0417 15.6111 21.25 14.4861 21.25 12.875L20.0625 14.0625L19 13L22 10L25 13L23.9375 14.0625L22.75 12.875C22.7361 14.8194 22.4514 16.2049 21.8958 17.0312C21.3403 17.8576 20.7778 18.5278 20.2083 19.0417C19.7778 19.4306 19.4271 19.816 19.1562 20.1979C18.8854 20.5799 18.75 21.1806 18.75 22V26H17.25ZM13.4375 15C13.3819 14.6944 13.3368 14.3646 13.3021 14.0104C13.2674 13.6563 13.25 13.2778 13.25 12.875L12.0625 14.0625L11 13L14 10L17 13L15.9375 14.0625L14.75 12.875C14.75 13.2222 14.7604 13.5417 14.7812 13.8333C14.8021 14.125 14.8333 14.3958 14.875 14.6458L13.4375 15ZM15.2708 18.5417C14.9653 18.2361 14.6701 17.8889 14.3854 17.5C14.1007 17.1111 13.8611 16.6042 13.6667 15.9792L15.125 15.6042C15.2778 16.0347 15.4583 16.3993 15.6667 16.6979C15.875 16.9965 16.0972 17.2639 16.3333 17.5L15.2708 18.5417Z",
                    fill: "#FFDF00"
                })
            })
        ]
    }));
};
